import './main.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n' // Import i18n configuration
import UpdateLaunchPrompt from './components/UpdateLaunchPrompt'
import DuplicateLaunchGate from './components/DuplicateLaunchGate'
import RootErrorBoundary from './components/RootErrorBoundary'
import { installFetchInterceptor } from './utils/fetchInterceptor'
import { runUploadIdbMigrationOnce } from './utils/uploadIdbMigration'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'

// Install fetch interceptor early, before React renders
installFetchInterceptor()

// One-time clear of legacy upload IndexedDB to prevent duplicate uploads (plan: Upload Migration Risk Analysis)
runUploadIdbMigrationOnce().catch(() => {})

const posthogKey = process.env.VITE_PUBLIC_POSTHOG_KEY
const posthogHost = process.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com'

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2025-05-24',
    loaded: (posthog) => {
      if (process.env.NODE_ENV === 'development') posthog.debug()
    }
  })
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      {/* Outermost, so a throw anywhere below — including in the launch gate —
          shows a readable screen instead of emptying #root into a white
          fullscreen kiosk. See components/RootErrorBoundary.tsx. */}
      <RootErrorBoundary>
        {/* A blank booth2 that old shells open when the app is started twice must not
            boot (or start an update). See utils/duplicateLaunch.ts. */}
        <DuplicateLaunchGate>
          <App />
          {/* Above every route: the app can open straight into an update countdown. */}
          <UpdateLaunchPrompt />
        </DuplicateLaunchGate>
      </RootErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
)
